<template>
    <div class="attendance-container">
      <!-- 消课记录 -->
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>消课记录</span>
        </div>
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="学员姓名">
            <el-input v-model="searchForm.xueyuanName" placeholder="请输入学员姓名" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="课程名称">
            <el-input v-model="searchForm.courseName" placeholder="请输入课程名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="出勤" value="present"></el-option>
              <el-option label="缺勤" value="absent"></el-option>
              <el-option label="请假" value="leave"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 关键修改：将表格数据改为 filteredRecords（过滤后的数据） -->
        <el-table :data="filteredRecords.slice((currentPage - 1) * pageSize, currentPage * pageSize)" 
          style="width: 100%"
          v-loading="loading">
          <el-table-column prop="xueyuanName" label="学员姓名"></el-table-column>
          <el-table-column prop="studentName" label="微信昵称"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="courseName" label="课程"></el-table-column>
          <el-table-column label="会员类型">
            <template slot-scope="scope">
              <el-tag :type="scope.row.memberType === 'package' ? 'success' : 'primary'">
                {{ scope.row.memberType === 'package' ? '课时包' : '包月包' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="attendanceDate" label="日期">
            <template slot-scope="scope">
              {{ formatDate(scope.row.attendanceDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="lessonCount" label="消课数量/类型">
            <template slot-scope="scope">
              {{ scope.row.memberType === 'package' ? `${scope.row.lessonCount || 1} 课时` : '月卡' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
      </el-card>
      
      <!-- 分页组件 -->
      <div class="pagination-container" style="text-align: right;margin-top: 10px;margin-right: 10px;">
        <!-- 关键修改：总条数改为 filteredRecords 的长度（过滤后的总数量） -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredRecords.length">
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        attendanceRecords: [], // 原始数据
        loading: false,
        currentPage: 1,
        pageSize: 10,
        searchForm: {
          xueyuanName: '',
          courseName: '',
          status: ''
        }
      }
    },
    computed: {
      filteredRecords() {
        return this.attendanceRecords.filter(record => {
          // 学员姓名筛选（不区分大小写，提高用户体验）
          if (this.searchForm.xueyuanName && 
              !record.xueyuanName?.toLowerCase().includes(this.searchForm.xueyuanName.toLowerCase())) {
            return false;
          }
          
          // 课程名称筛选（不区分大小写）
          if (this.searchForm.courseName && 
              !record.courseName?.toLowerCase().includes(this.searchForm.courseName.toLowerCase())) {
            return false;
          }
          
          // 状态筛选
          if (this.searchForm.status && 
              record.status !== this.searchForm.status) {
            return false;
          }
          
          return true;
        });
      }
    },
    created() {
      this.fetchAttendanceRecords();
    },
    methods: {
      fetchAttendanceRecords() {
        this.loading = true;
        this.$http.get('/api/attendances')
        .then(response => {
          console.log('消课记录', response.data.data);
          this.attendanceRecords = response.data.data || []; // 防止数据为null
          this.loading = false;
        })
        .catch(error => {
          console.error('获取消课记录失败:', error);
          this.$message.error('获取消课记录失败');
          this.loading = false;
        });
      },
      handleSearch() {
        this.currentPage = 1; // 搜索时重置到第一页
      },
      resetSearch() {
        this.searchForm = {
          xueyuanName: '',
          courseName: '',
          status: ''
        };
        this.currentPage = 1; // 重置后回到第一页
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1; // 改变每页条数时重置到第一页
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      formatDate(date, format = 'YYYY-MM-DD HH:mm') {
        if (!date) return '';
        const d = new Date(date);
        // 修复日期格式化可能出现的NaN问题
        if (isNaN(d.getTime())) return '';
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
      },
      getStatusTagType(status) {
        const map = {
          present: 'success',
          absent: 'danger',
          leave: 'warning'
        };
        return map[status] || '';
      },
      getStatusText(status) {
        const map = {
          present: '出勤',
          absent: '缺勤',
          leave: '请假'
        };
        return map[status] || status;
      }
    }
  }
  </script>
  
  <style scoped>
  .attendance-container {
    padding: 0 20px;
  }
  .box-card {
    margin-bottom: 20px;
  }
  .search-form {
    margin-bottom: 20px;
  }
  </style>